(function () {
  function getFormId(button) {
    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var mobileId = button.getAttribute('data-klaviyo-form-mobile') || '';
    var desktopId = button.getAttribute('data-klaviyo-form-desktop') || '';
    return (isMobile ? mobileId || desktopId : desktopId || mobileId).trim();
  }

  function openKlaviyoForm(formId) {
    if (!formId) return;
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.pki__trigger');
    if (!button) return;
    event.preventDefault();
    openKlaviyoForm(getFormId(button));
  });
})();
